import { render, staticRenderFns } from "./SyncIntranetIdBox.vue?vue&type=template&id=2c69c494&scoped=true"
import script from "./SyncIntranetIdBox.vue?vue&type=script&lang=js"
export * from "./SyncIntranetIdBox.vue?vue&type=script&lang=js"
import style0 from "./SyncIntranetIdBox.vue?vue&type=style&index=0&id=2c69c494&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c69c494",
  null
  
)

export default component.exports